// extracted by mini-css-extract-plugin
export default {"form":"PasswordChangeForm_form__aDP83","form_active":"PasswordChangeForm_form_active__ejx88","title":"PasswordChangeForm_title__PqWR1","change":"PasswordChangeForm_change__9hgGU"};